import React from 'react'
import styled from 'styled-components'
import { SchoolDetailsSectionSubTitle } from '../School/SchoolDetailsSectionTitle'

const StyledSchoolAbout = styled.div``

const AboutText = styled.div``

interface ISchoolAboutProps {
  about: string
}

const SchoolAbout: React.FC<ISchoolAboutProps> = ({ about }) => (
  <StyledSchoolAbout>
    <SchoolDetailsSectionSubTitle>About</SchoolDetailsSectionSubTitle>
    <AboutText
      dangerouslySetInnerHTML={{ __html: about.replace(/\n/g, '<br />') }}
    />
  </StyledSchoolAbout>
)

export { SchoolAbout }
